import axios from 'axios';
import store from '@/store';
import i18n from '@/i18n';
import { EMAIL_CAMPAIGNS_API_URL } from './url';
import endpointVersion from '@/helpers/endpoint-version';
export const putCampaignEmail = async (payload, campaignId) => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store?.state?.auth?.tokenV3 ?? '';
    if (!brand?.id) {
        throw new Error(i18n.global.t('breadcrumb.email.campaigns.errors.brand-id-not-available'));
    }
    if (!tokenV3) {
        throw new Error(i18n.global.t('breadcrumb.email.campaigns.errors.auth-token-not-available'));
    }
    const preheaderValue = payload.preheader?.trim() === '' ? null : payload.preheader;
    const backendPayload = {
        name: payload.name,
        audience_id: payload.audienceId,
        title: payload.title,
        preheader: preheaderValue,
        preheader_text: preheaderValue,
        sender_name: payload.senderName,
        sender_email: payload.senderEmail,
        category_id: payload.categoryId,
        reply_to_email: payload.replyToEmail || payload.senderEmail,
        template: payload.template,
        is_scheduled: payload.isScheduled || false,
        scheduled_at: payload.scheduleAt || undefined,
        is_recurrent: payload.isRecurrent || false,
        notes: payload.notes || undefined,
        ip_pool_name: payload.ipPoolName || undefined,
    };
    const emailCampaignsApi = EMAIL_CAMPAIGNS_API_URL.replace(/\/$/, '') || '';
    const hasCustomBase = Boolean(emailCampaignsApi);
    const base = (hasCustomBase ? emailCampaignsApi : endpointVersion('v3')).replace(/\/$/, '');
    const path = `/campaigns/${campaignId}`;
    const url = `${base}${path}`;
    const res = await axios.put(url, backendPayload, {
        params: { brand_id: brand.id },
        headers: {
            'Content-Type': 'application/json',
            ...(tokenV3 && { Authorization: `Bearer ${tokenV3}` }),
        },
    });
    return { data: res.data };
};
